import { render, staticRenderFns } from "./listaTipoProduto.vue?vue&type=template&id=5549f444&scoped=true&"
import script from "./listaTipoProduto.vue?vue&type=script&lang=js&"
export * from "./listaTipoProduto.vue?vue&type=script&lang=js&"
import style0 from "./listaTipoProduto.vue?vue&type=style&index=0&id=5549f444&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5549f444",
  null
  
)

export default component.exports